import PropTypes from 'prop-types'
import { useRef, useEffect, useState, useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import { UserContext } from '../../context/UserContext'

const emptyClass = ' not-empty'
const revealClass = ' is-revealed'
const activeClass = ' is-active'

const FormItemHidden = (props) => {
  const { item, onFormItemLoad, groupedState, revealState } = props

  const { register, watch, setValue } = useFormContext()
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const [isGrouped, setIsGrouped] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const [defaultValue, setDefaultValue] = useState(item.transl ? t(item.value) : item.value)

  const itemRef = useRef()

  const itemValue = watch(item.name)
  const itemProps = item

  useEffect(() => {
    if (isLoaded === false && itemValue) {
      onFormItemLoad({ itemProps, itemRef, itemValue })
      setDefaultValue(itemValue)
      setIsLoaded(true)
    }
  }, [itemValue])

  useEffect(() => {
    if (item?.group && groupedState) {
      const itemLabel = item?.group?.label
      const groupedItem = groupedState.filter((str) => {
        return str.label.indexOf(itemLabel) >= 0
      })
      setIsGrouped(groupedItem[0].active)
    }
  }, [groupedState])

  useEffect(() => {
    if (item.label === 'URL' && window !== 'undefined') setValue(item.name, window.location.href)
  }, [item])

  return (
    <div
      ref={itemRef}
      className={`FormItem FormItem--${item.type}${item.modifier ? ` FormItem--${item.modifier}` : ''}${
        itemValue ? emptyClass : ''
      }${revealState ? revealClass : ''}${!isGrouped ? '' : activeClass}`}
      data-reveal-target={item.revealed}
    >
      <input
        type="hidden"
        id={item.name}
        defaultValue={defaultValue}
        name={item.name}
        className={`FormItem-input FormItem-input--${item.type}`}
        {...register(item.name)}
      />
    </div>
  )
}

FormItemHidden.propTypes = {
  item: PropTypes.object,
  onFormItemLoad: PropTypes.func,
  revealState: PropTypes.any,
  groupedState: PropTypes.any
}

export default FormItemHidden
